import { useTranslation } from 'react-i18next'

import HistoryDrawer from '@/common/components/HistoryDrawer/HistoryDrawer'

import { inventoryFieldKeyPrefix } from './constants'
import { formatInventoryEvent } from './helpers'

const InventoryHistoryDrawer = ({ show, onClose, returnPortalId }) => {
  const { t } = useTranslation()

  const formatEvent = event => formatInventoryEvent(event, t)

  return (
    <HistoryDrawer
      show={show}
      onClose={onClose}
      title={t('Historial de la página')}
      fieldKeyPrefix={inventoryFieldKeyPrefix}
      returnPortalId={returnPortalId}
      formatEvent={formatEvent}
    />
  )
}

export default InventoryHistoryDrawer
